import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Input, DatePicker, InputNumber, Icon } from 'antd';
import { getTimeSetting } from 'utils/dateTimeUtils';
import Enums from 'utils/EnumsManager';
import { AutoConvertedDatePicker } from 'components/ui/index';

const {
  DateOnly,
  DateTime,
  Email,
  LongText,
  Lookup,
  NumberInput,
  PickList,
  TextInput,
} = Enums.FieldTypes;

const defaultProps = {
  handleAddonClick: null,
  handleTimeRangeChange: null,
  handleValueChange: null,
};
const propTypes = {
  displayNum: PropTypes.number.isRequired,
  type: PropTypes.oneOf(Enums.FieldTypesInArray).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]).isRequired,
  handleAddonClick: PropTypes.func,
  handleValueChange: PropTypes.func,
  handleTimeRangeChange: PropTypes.func,
};

const ValueCriteriaField = ({
  displayNum,
  criterion,
  type,
  handleValueChange,
  handleAddonClick,
  handleTimeRangeChange,
  value,
}) => {
  switch (type) {
    case DateOnly:
    case DateTime:
      return (
        <AutoConvertedDatePicker
          displayNum={displayNum}
          type={type}
          value={value}
          onChange={(date, dateString) => handleValueChange(dateString, displayNum)}
        />
      );
    case NumberInput:
      // TODO: add scale and precision as restriction rules
      return (
        <InputNumber
          className="full-width"
          size="small"
          onChange={num => handleValueChange(num, displayNum)}
          value={value}
        />
      );
    case PickList:
    case Lookup:
      return (
        <Input
          size="small"
          addonAfter={<Icon type="search" onClick={e => handleAddonClick(criterion)} />}
          onChange={e => handleValueChange(e.target.value, displayNum)}
          value={value}
        />
      );
    case Email:
    case LongText:
    case TextInput:
      return <Input size="small" onChange={e => handleValueChange(e.target.value, displayNum)} value={value} />;
    default:
      throw Error('No such type in ValueCriteriaField component.');
  }
};

ValueCriteriaField.defaultProps = defaultProps;
ValueCriteriaField.propTypes = propTypes;
export default ValueCriteriaField;



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria/components/ValueCriteriaField/index.jsx